export default __webpack_public_path__ + "static/media/C4.e6af0fe5.png";